import cookiesParams from './cookiesParams';
import { getCookieDomain } from './setCookie';

export function deleteCookie(name) {
  const domain = getCookieDomain(window.location.hostname);
  const isHttps = window.location.protocol === 'https:';
  const past = 'Thu, 01 Jan 1970 00:00:00 GMT';

  // Must match the same attributes used when setting the cookie (see setCookie.js)
  // Chrome requires Secure when SameSite=None; on HTTP use Lax instead
  const sameSite = isHttps ? 'None' : 'Lax';
  const secureAttr = isHttps ? ';Secure' : '';

  // 1) Match main domain (how we set it)
  document.cookie = `${name}=;expires=${past};max-age=0;domain=${domain};path=/;SameSite=${sameSite}${secureAttr}`;
  // 2) Also clear host-only cookie (covers older or mismatched sets)
  document.cookie = `${name}=;expires=${past};max-age=0;path=/;SameSite=${sameSite}${secureAttr}`;
}

export function deleteAuthCookie() {
  deleteCookie(cookiesParams.auth.name);
}

/* GP-608: Deprecated. The original intention was to delete the cookie by setting its expire to a past date and/or setting the max-age to 0.
 * However, this does not seem to work in some browsers, such as Firefox. Expired cookies were not removed from the browser.
 * Instead, the value is now set as false, and expiry set as empty string (thus converting it to a session cookie).
 */
export function deleteReloadBookingCookie() {
  deleteCookie(cookiesParams.loadBookingsFlag.name);
}
